import request from "@/common/request.js";

export function PublicationList(data) {
  return request({
    url: "/system/achievements/listPublication",
    method: "post",
    params: data,
  });
}

export function ProjectList(data) {
  return request({
    url: "/system/achievements/listProject",
    method: "post",
    params: data,
  });
}

export function PatentList(data) {
  return request({
    url: "/system/achievements/listPatent",
    method: "post",
    params: data,
  });
}

export function PwardList(data) {
  return request({
    url: "/system/achievements/listPward",
    method: "post",
    params: data,
  });
}

// 成果视频列表
export function VideoList(data) {
  return request({
    url: "/system/achievements/listVideo",
    method: "post",
    params: data,
  });
}

